<template>
    <div class="region-selection">

        <transition name="fade">
            <div v-show="isLoading" class="region-selection__preloader">
                <div class="spinner-border spinner-border-sm" role="status"></div>
            </div>
        </transition>

        <div class="region-selection__search">
            <search-input-form
                data-focus-on-modal-show
                v-model="query"
                placeholder="Введите ваш город"
                @keyup.enter.prevent="enterSearchHandler"
            />
        </div>
        <div class="region-selection__list-expander">
            <simplebar class="region-selection__list-wrapper">
                <ul class="region-selection__list" v-if="filteredRegions.length">
                    <li class="region-selection__item" @click.prevent="setExactGeo" ><a class="region-selection__link region-selection__link-custom"><b>Выбрать автоматически</b></a></li>
                    <li class="region-selection__item" v-for="region in filteredRegions" :key="region.ID">
                        <a
                            class="region-selection__link"
                            :class="region.NAME_RU === settledRegion ? 'region-selection__link--active' : ''"
                            @click.prevent="selectRegion(region)"
                        >
                            {{ region.NAME_RU }}
                        </a>
                    </li>
                </ul>
                <p v-else class="region-selection__empty">Город не найден</p>
            </simplebar>
        </div>
    </div>
</template>

<script>
import { ajaxRequest } from '../../services/ajax-service';

import SearchInputForm from '../ui/search-input-form';

export default {
    name: 'region-selection',

    components: { SearchInputForm },

    inject: ['$userGeoService', '$basketService'],

    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            // regions: [...Object.values(window.specialtyApp.cities)],
            regions: [],
            query: '',

            isLoading: false,
            error: null,

            isInit: false,
        };
    },

    methods: {
        enterSearchHandler() {
            if (!this.query || !this.filteredRegions.length) {
                return;
            }

            this.selectRegion(this.filteredRegions[0]);
        },

        selectRegion(region) {
            this.$userGeoService.confirmRegion();
            this.$userGeoService.setRegion(region.NAME_RU);
        },
        setExactGeo() {
            // let exactGeo = '';
            navigator.geolocation.getCurrentPosition(
                // Функция обратного вызова при успешном извлечении локации
                (position) => {
                    // P-270: город по координатам — через нашу серверную ручку (ключ DaData только на сервере)
                    ajaxRequest('/api/search/geolocate/', {
                        type: 'post',
                        data: { lat: position.coords.latitude, lon: position.coords.longitude },
                    })
                        .then((response) => {
                            let city = response.data?.data?.CITY;
                            if (!city) {
                                window.alert('Не удалось определить город автоматически. Выберите его из списка.');
                                return;
                            }
                            BX.setCookie('confirmed_city', '1', { expires: 30 });
                            BX.setCookie('current_city', city, { expires: 86400, path: '/' });
                            $('a[data-target="#regionModal"] span').html(city);
                            // exactGeo = city;
                            const lastLetter = city.slice(-1);
                            if (lastLetter.toLowerCase() === 'a') {
                                city = `${city.substr(0, city.length - 1)}у`;
                            }
                            // console.log(window.specialtyApp.basketService.state.currentDelivery);
                            // this.$basketService.changeCity(window.specialtyApp.basketService.state.currentDelivery, exactGeo, true);
                            const links = $('.basket-notifications-handler__city-link');

                            if (links.length) {
                                links.each((idx, el) => {
                                    $(el).html(city);
                                });
                            }

                            $('#regionModal').modal('hide');
                            $('.region-confirm__question').html(`<span>Ваш город<span class="d-none d-sm-inline"> — </span></span>${city}<strong class="d-none d-sm-inline">?</strong>`);

                            window.location.reload();
                        })
                        .catch((error) => {
                            console.log('error', error);
                            window.alert('Не удалось определить город автоматически. Выберите его из списка.');
                        });
                },

                // Функция обратного вызова при неуспешном извлечении локации
                (error) => {
                    console.log(error);
                },
            );
        },
        getCities() {
            this.isInit = true;
            this.isLoading = true;
            this.error = null;

            ajaxRequest('/api/order/cities/', { type: 'get' })
                .then((response) => {
                    const { data, status, message } = response.data;

                    if (status !== 'success') {
                        this.error = message;
                        return;
                    }

                    this.regions = data;
                })
                .catch(() => {
                    this.error = 'Не удалось загрузить список городов';
                    this.isInit = false;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        changeKeyboardLayout(str) {
            const replacer = {
                q: 'й',
                w: 'ц',
                e: 'у',
                r: 'к',
                t: 'е',
                y: 'н',
                u: 'г',
                i: 'ш',
                o: 'щ',
                p: 'з',
                '[': 'х',
                ']': 'ъ',
                a: 'ф',
                s: 'ы',
                d: 'в',
                f: 'а',
                g: 'п',
                h: 'р',
                j: 'о',
                k: 'л',
                l: 'д',
                ';': 'ж',
                '\'': 'э',
                z: 'я',
                x: 'ч',
                c: 'с',
                v: 'м',
                b: 'и',
                n: 'т',
                m: 'ь',
                ',': 'б',
                '.': 'ю',
                '/': '.',
            };

            let newStr = '';
            for (let i = 0; i < str.length; i += 1) {
                if (replacer[str[i]] === undefined) {
                    newStr += str[i];
                } else {
                    newStr += replacer[str[i]];
                }
            }

            return newStr;
        },

    },

    computed: {
        filteredRegions() {
            if (this.query.length <= 2) {
                return [...this.sortedRegions];
            }

            let translatedStr = this.query.toLocaleLowerCase();

            if (/(?=.*[a-z])/i.test(translatedStr)) {
                translatedStr = this.changeKeyboardLayout(this.query.toLocaleLowerCase());
            }

            return this.sortedRegions.filter(({ NAME_RU }) => NAME_RU.toLocaleLowerCase().includes(translatedStr));
        },
        sortedRegions() {
            return [...this.regions].sort((a, b) => {
                const cityA = parseInt(a.SORT, 10);
                const cityB = parseInt(b.SORT, 10);
                if (cityA < cityB) {
                    return -1;
                }
                if (cityA > cityB) {
                    return 1;
                }
                return 0;
            });
        },
        settledRegion() {
            return this.$userGeoService.getSettledRegion();
        },
    },

    watch: {
        isOpen: {
            immediate: true,
            handler(value) {
                if (this.isInit) return;

                if (value) {
                    this.getCities();
                }
            },
        },
    },
};
</script>
